var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationBell = function SvgNotificationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0456 3.51656C34.9793 2.88459 32.7856 2.54456 30.5124 2.54456C18.1929 2.54456 8.206 12.5316 8.206 24.851L8.206 41.9869C8.206 46.0444 2.62939 46.0444 2.62939 51.6187C2.62939 54.6984 5.1259 57.1953 8.206 57.1953L52.8189 57.1953C55.8988 57.1953 58.3955 54.6984 58.3955 51.6187C58.3955 46.0352 52.8189 46.0352 52.8189 41.9869V40.4655",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.502 66.2639H40.5379",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9719 18.8906C63.9719 25.2624 58.8066 30.4278 52.4347 30.4278C46.0628 30.4278 40.8975 25.2624 40.8975 18.8906C40.8975 12.5187 46.0628 7.35334 52.4347 7.35334C58.8066 7.35334 63.9719 12.5187 63.9719 18.8906Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.1914,
    y: 12.35,
    width: 2.5,
    height: 13.08,
    rx: 1.25,
    fill: "#757575"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9814,
    y: 17.6401,
    width: 2.5,
    height: 13.08,
    rx: 1.25,
    transform: "rotate(90 58.9814 17.6401)",
    fill: "#757575"
  })));
};
export default SvgNotificationBell;